import { apm } from '@elastic/apm-rum'
import RequestsBuilder from '../../utils/redux/RequestsBuilder'
import {
  beautyProcedure,
  gamePause,
  generateName,
  saveToken,
  update,
  getBeautiesBalance,
  setCountry,
  getUserProfile,
  getAttempts,
  getUserPrizes,
} from '../../api/user'
import {
  addFriend,
  auth,
  buyItem,
  buyLootBoxById,
  buyPremium,
  buyPrize,
  buyQuiz,
  buyWishGift,
  checkGuessPrice,
  collectQuest,
  completeQuest,
  endBeautyRoutine,
  equipItem,
  fromGachaToAttempts,
  gameEnd,
  gameStart,
  getAccessToken,
  getBeautyRoutine,
  getBuyProducts,
  getCurrentQuiz,
  getFavorites,
  getFavoritesProducts,
  getFriend,
  getGameRating,
  getGameSettings,
  getGrades,
  getGuessPriceTodayList,
  getIcons,
  getIconsByUid,
  getIndex,
  getLootBoxesList,
  getModals,
  getOldWeekRating,
  getParams,
  getQuests,
  getQuizQuests,
  getRareRating,
  getRating,
  getServiceData,
  getShopItems,
  getTgBonuses,
  getTgEnergy,
  getTgGifts,
  getTgMoney,
  getTgTickets,
  getUserData,
  getUserGameRating,
  getUserRareRating,
  getUserRating,
  getUserWeekRating,
  getWebCatalogProductsBySku,
  getWebCatalogProductsBySkuBeautyRoutine,
  getWeekRating,
  getWishes,
  getWishUserData,
  getWishUserItems,
  getYearStat,
  openCustomModal,
  productToCart,
  productToFavorites,
  returnAttempts,
  saveServiceData,
  saveServiceModal,
  saveShareImage,
  sendGameProgress,
  sendWish,
  setActiveRoom,
  setDislike,
  setLike,
  setPremiumIcon,
  spfGameEnd,
  spfGameExit,
  spfGameStart,
  submitCurrentQuizResult,
  submitQuizQuest,
  useBuyProduct,
  markDisposableModalAsShown,
  gachaConvertBonuses,
  convertCoins,
  convertToCoins,
  getShopPrizes,
} from '../../api/content'
import { isLocalhost } from '../../utils/is-localhost'
import { featureToggleOverrides } from '../../constants/feature-toggle.overrides'
import { defaultStore, stores } from '../../translations'
import getDrawingResultWinners from '../../components/features/drawingResult/api/getDrawingResultWinners'
import { trackGameOpen } from '../../api/maestra'

const builder = new RequestsBuilder({
  name: 'requests',
  initialState: {
    phone: null,
    registrationData: null,
    message: null,
    authData: {
      isWeb: true,
      share: null,
      timestamp: '',
      smsSigned: null,
      emailSigned: null,
      pushSigned: null,
      phone: null,
      deviceId: null,
      groupId: null,
      featureToggles: null,
    },
    appInfoData: {
      debug: null,
      baseUrl: null,
      deviceId: null,
      isWeb: null,
      languageCodeOptions: null,
      plaidHeaders: null,
      store: defaultStore,
    },
  },

  reducers: {
    clearError(state, { payload: { field, requestName } = {} }) {
      if (!field) return

      requestName = builder.getRequestByName(requestName)

      const requestData = state.requests[`requests/${requestName}`]
      if (!requestData?.error?.fields?.[field]) return

      delete requestData.error.fields[field]

      if (!Object.keys(requestData.error.fields).length) requestData.error = null
    },
    savePhone(state, { payload }) {
      if (payload.phone) {
        state.phone = payload.phone

        apm.addLabels({ phone: payload.phone })
      }
    },
    savePersonData(state, { payload }) {
      const authData = { ...payload }
      delete authData.ecomToken

      state.authData = {
        ...state.authData,
        ...authData,
        featureToggles: {
          ...authData.featureToggles,
          ...(isLocalhost() ? featureToggleOverrides : {}),
        },
      }

      if (authData.phone) {
        apm.addLabels({ phone: authData.phone })
      }

      if (authData.deviceId) {
        apm.addLabels({ deviceId: authData.deviceId })
      }

      if (authData.sessionID) {
        apm.addLabels({ customerId: authData.sessionID })
      }

      saveToken(authData)
    },
    setAppInfoData(state, { payload: appInfoData }) {
      // Вычисляем код страны из baseUrl
      // Формат baseUrl: goldapple.ru, goldapple.qa, goldapple.ae и т.д.
      // Код страны - это TLD (top-level domain) в конце домена
      let store = null
      if (appInfoData?.baseUrl) {
        const baseUrl = appInfoData.baseUrl
        // Извлекаем домен из baseUrl (может быть полный URL или только домен)
        let domain = baseUrl
        try {
          // Если это полный URL, извлекаем hostname
          if (baseUrl.includes('://')) {
            const url = new URL(baseUrl)
            domain = url.hostname
          } else if (baseUrl.includes('/')) {
            // Если есть путь, берем только доменную часть
            domain = baseUrl.split('/')[0]
          }
        } catch (e) {
          // Если не удалось распарсить, используем baseUrl как есть
          domain = baseUrl
        }

        // Извлекаем TLD (последняя часть домена после последней точки)
        // Например: goldapple.ru -> ru, goldapple.qa -> qa
        const domainParts = domain.split('.')
        const tld = domainParts[domainParts.length - 1]

        // Ищем store по TLD
        if (tld && Object.values(stores).includes(tld)) {
          store = tld
        }
      }

      // Если store не определен, используем defaultStore
      if (!store) {
        store = defaultStore
      }

      state.appInfoData = {
        ...appInfoData,
        store,
      }
    },
  },
})
  .addRequest({
    requestName: 'user/update',
    extraName: 'userUpdate',
    checkLocal: true,
    func: update,
  })
  .addRequest({
    requestName: 'user/set-country',
    extraName: 'setCountry',
    checkLocal: true,
    func: setCountry,
  })
  .addRequest({
    requestName: 'user/generate-username',
    extraName: 'generateName',
    checkLocal: true,
    func: generateName,
  })
  .addRequest({
    requestName: 'game/beauty-procedure',
    extraName: 'beautyProcedure',
    checkLocal: true,
    func: beautyProcedure,
  })
  .addRequest({
    requestName: 'shop/shop-items',
    extraName: 'shopItems',
    checkLocal: false,
    func: getShopItems,
  })
  .addRequest({
    requestName: 'user/add-friend',
    extraName: 'addFriend',
    checkLocal: true,
    func: addFriend,
  })
  .addRequest({
    requestName: 'user/get-friend',
    extraName: 'getFriend',
    checkLocal: true,
    func: getFriend,
  })
  .addRequest({
    requestName: 'user/get-wish-user-data',
    extraName: 'getWishUserData',
    checkLocal: true,
    func: getWishUserData,
  })
  .addRequest({
    requestName: 'user/get-user-data',
    extraName: 'getUserData',
    checkLocal: true,
    func: getUserData,
  })
  .addRequest({
    requestName: 'user/get-favorites',
    extraName: 'getFavorites',
    checkLocal: false,
    func: getFavorites,
  })
  .addRequest({
    requestName: 'user/set-like',
    extraName: 'setLike',
    checkLocal: true,
    func: setLike,
  })
  .addRequest({
    requestName: 'wish/get-user-items',
    extraName: 'getWishUserItems',
    checkLocal: true,
    func: getWishUserItems,
  })
  .addRequest({
    requestName: 'user/set-dislike',
    extraName: 'setDislike',
    checkLocal: true,
    func: setDislike,
  })
  .addRequest({
    requestName: 'game/get-current-quiz',
    extraName: 'getCurrentQuiz',
    checkLocal: true,
    func: getCurrentQuiz,
  })
  .addRequest({
    requestName: 'game/buy-quiz',
    extraName: 'buyQuiz',
    checkLocal: true,
    func: buyQuiz,
  })
  .addRequest({
    requestName: 'game/submit-current-quiz-result',
    extraName: 'submitCurrentQuizResult',
    checkLocal: true,
    func: submitCurrentQuizResult,
  })
  .addRequest({
    requestName: 'shop/buy-item',
    extraName: 'buyItem',
    checkLocal: true,
    func: buyItem,
  })
  .addRequest({
    requestName: 'shop/equip-item',
    extraName: 'equipItem',
    checkLocal: true,
    func: equipItem,
  })
  .addRequest({
    requestName: 'game/get-rating',
    extraName: 'getRating',
    checkLocal: true,
    func: getRating,
  })
  .addRequest({
    requestName: 'game/old-week-rating',
    extraName: 'getOldWeekRating',
    checkLocal: false,
    func: getOldWeekRating,
  })
  .addRequest({
    requestName: 'game/get-week-rating',
    extraName: 'getWeekRating',
    checkLocal: true,
    func: getWeekRating,
  })
  .addRequest({
    requestName: 'game/user-rating',
    extraName: 'getUserRating',
    checkLocal: true,
    func: getUserRating,
  })
  .addRequest({
    requestName: 'game/user-week-rating',
    extraName: 'getUserWeekRating',
    checkLocal: true,
    func: getUserWeekRating,
  })
  .addRequest({
    requestName: 'game/get-quests',
    extraName: 'getQuests',
    checkLocal: false,
    func: getQuests,
  })
  .addRequest({
    requestName: 'game/collect-quest',
    extraName: 'collectQuest',
    checkLocal: false,
    func: collectQuest,
  })
  .addRequest({
    requestName: 'game/complete-quest',
    extraName: 'completeQuest',
    checkLocal: false,
    func: completeQuest,
  })
  .addRequest({
    requestName: 'game/start',
    extraName: 'gameStart',
    checkLocal: true,
    func: gameStart,
  })
  .addRequest({
    requestName: 'game/get-game-rating',
    extraName: 'getGameRating',
    checkLocal: false,
    func: getGameRating,
  })
  .addRequest({
    requestName: 'game/get-user-game-rating',
    extraName: 'getUserGameRating',
    checkLocal: false,
    func: getUserGameRating,
  })
  .addRequest({
    requestName: 'game/end',
    extraName: 'gameEnd',
    checkLocal: true,
    func: gameEnd,
  })
  .addRequest({
    requestName: 'game/start-hidden-object',
    extraName: 'spfGameStart',
    checkLocal: true,
    func: spfGameStart,
  })
  .addRequest({
    requestName: 'game/end-hidden-object',
    extraName: 'spfGameEnd',
    checkLocal: true,
    func: spfGameEnd,
  })

  .addRequest({
    requestName: 'game/exit-hidden-object',
    extraName: 'spfGameExit',
    checkLocal: true,
    func: spfGameExit,
  })
  .addRequest({
    requestName: 'game/pause',
    extraName: 'gamePause',
    checkLocal: true,
    func: gamePause,
  })
  .addRequest({
    requestName: 'game/get-index',
    checkLocal: false,
    extraName: 'getIndex',
    func: getIndex,
  })
  .addRequest({
    requestName: 'shop/buy-prize',
    extraName: 'buyPrize',
    checkLocal: true,
    func: buyPrize,
  })
  .addRequest({
    requestName: 'game/get-game-settings',
    extraName: 'getGameSettings',
    func: getGameSettings,
  })
  .addRequest({
    requestName: 'user/service-data-modal-save',
    extraName: 'saveServiceModal',
    func: saveServiceModal,
  })
  .addRequest({
    requestName: 'user/service-data-save',
    extraName: 'saveServiceData',
    func: saveServiceData,
  })
  .addRequest({
    requestName: 'user/service-data-get',
    extraName: 'getServiceData',
    func: getServiceData,
  })
  .addRequest({
    requestName: 'user/get-access-token',
    extraName: 'getAccessToken',
    checkLocal: true,
    func: getAccessToken,
  })
  .addRequest({
    requestName: 'user/save-share-image',
    extraName: 'saveShareImage',
    checkLocal: true,
    func: saveShareImage,
  })
  .addRequest({
    requestName: 'prizes/get',
    extraName: 'getShopPrizes',
    checkLocal: true,
    func: getShopPrizes,
  })
  .addRequest({
    requestName: 'data/grades',
    extraName: 'getGrades',
    checkLocal: true,
    func: getGrades,
  })
  .addRequest({
    requestName: 'params/index',
    extraName: 'getParams',
    checkLocal: false,
    async func(data, stateData) {
      const response = await getParams(data)
      const store = stateData?.appInfoData?.store ?? null

      return { ...response, store }
    },
  })
  .addRequest({
    requestName: 'user/set-active-room',
    extraName: 'setActiveRoom',
    checkLocal: true,
    func: setActiveRoom,
  })
  .addRequest({
    requestName: 'drawing-result/winners/get',
    extraName: 'getDrawingResultWinners',
    checkLocal: false,
    func: getDrawingResultWinners,
  })
  .addRequest({
    requestName: 'gacha/list',
    extraName: 'getLootBoxesList',
    checkLocal: true,
    func: getLootBoxesList,
  })
  .addRequest({
    requestName: 'premium/buy',
    extraName: 'buyPremium',
    checkLocal: true,
    func: buyPremium,
  })
  .addRequest({
    requestName: 'gacha/open',
    extraName: 'buyLootBoxById',
    checkLocal: true,
    func: buyLootBoxById,
  })
  .addRequest({
    requestName: 'rating/get-rare-rating',
    extraName: 'getRareRating',
    checkLocal: true,
    func: getRareRating,
  })
  .addRequest({
    requestName: 'rating/get-user-rare-rating',
    extraName: 'getUserRareRating',
    checkLocal: true,
    func: getUserRareRating,
  })
  .addRequest({
    requestName: 'get-buy-products',
    extraName: 'getBuyProducts',
    checkLocal: true,
    func: getBuyProducts,
  })
  .addRequest({
    requestName: 'use-buy-product',
    extraName: 'useBuyProduct',
    checkLocal: true,
    func: useBuyProduct,
  })
  .addRequest({
    requestName: 'product-to-favorites',
    extraName: 'productToFavorites',
    checkLocal: true,
    func: productToFavorites,
  })
  .addRequest({
    requestName: 'product-to-cart',
    extraName: 'productToCart',
    checkLocal: true,
    func: productToCart,
  })
  .addRequest({
    requestName: 'get-favorites-products',
    extraName: 'getFavoritesProducts',
    checkLocal: false,
    func: getFavoritesProducts,
  })
  .addRequest({
    requestName: 'get-web-catalog-products-by-sku',
    extraName: 'getWebCatalogProductsBySku',
    checkLocal: true,
    func: getWebCatalogProductsBySku,
  })
  .addRequest({
    requestName: 'get-web-catalog-products-by-sku-beauty-routine',
    extraName: 'getWebCatalogProductsBySkuBeautyRoutine',
    checkLocal: true,
    func: getWebCatalogProductsBySkuBeautyRoutine,
  })
  .addRequest({
    requestName: 'return-attempts',
    extraName: 'returnAttempts',
    checkLocal: true,
    func: returnAttempts,
  })
  .addRequest({
    requestName: 'get-tg-bonuses',
    extraName: 'getTgBonuses',
    checkLocal: true,
    func: getTgBonuses,
  })
  .addRequest({
    requestName: 'get-tg-energy',
    extraName: 'getTgEnergy',
    checkLocal: true,
    func: getTgEnergy,
  })
  .addRequest({
    requestName: 'get-tg-money',
    extraName: 'getTgMoney',
    checkLocal: true,
    func: getTgMoney,
  })
  .addRequest({
    requestName: 'get-tg-tickets',
    extraName: 'getTgTickets',
    checkLocal: true,
    func: getTgTickets,
  })
  .addRequest({
    requestName: 'get-tg-gifts',
    extraName: 'getTgGifts',
    checkLocal: true,
    func: getTgGifts,
  })
  .addRequest({
    requestName: 'get-modals',
    extraName: 'getModals',
    checkLocal: true,
    func: getModals,
  })
  .addRequest({
    requestName: 'send-game-progress',
    extraName: 'sendGameProgress',
    checkLocal: true,
    func: sendGameProgress,
  })
  .addRequest({
    requestName: 'get-beauty-routine',
    extraName: 'getBeautyRoutine',
    checkLocal: true,
    func: getBeautyRoutine,
  })
  .addRequest({
    requestName: 'end-beauty-routine',
    extraName: 'endBeautyRoutine',
    checkLocal: true,
    func: endBeautyRoutine,
  })
  .addRequest({
    requestName: 'from-gacha-to-attempts',
    extraName: 'fromGachaToAttempts',
    checkLocal: true,
    func: fromGachaToAttempts,
  })
  .addRequest({
    requestName: 'wish-send',
    extraName: 'sendWish',
    checkLocal: true,
    func: sendWish,
  })
  .addRequest({
    requestName: 'wish-get',
    extraName: 'getWishes',
    checkLocal: true,
    func: getWishes,
  })
  .addRequest({
    requestName: 'wish-buy-gift',
    extraName: 'buyWishGift',
    checkLocal: true,
    func: buyWishGift,
  })
  .addRequest({
    requestName: 'set-premium-icon',
    extraName: 'setPremiumIcon',
    checkLocal: true,
    func: setPremiumIcon,
  })
  .addRequest({
    requestName: 'get-quiz-quests',
    extraName: 'getQuizQuests',
    checkLocal: true,
    func: getQuizQuests,
  })
  .addRequest({
    requestName: 'submit-quiz-quest',
    extraName: 'submitQuizQuest',
    checkLocal: true,
    func: submitQuizQuest,
  })
  .addRequest({
    requestName: 'open-custom-modal',
    extraName: 'openCustomModal',
    checkLocal: true,
    func: openCustomModal,
  })
  .addRequest({
    requestName: 'data/icons',
    extraName: 'getIcons',
    checkLocal: false,
    func: getIcons,
  })
  .addRequest({
    requestName: 'data/icons/get-by-uid',
    extraName: 'getIconsByUid',
    checkLocal: true,
    func: getIconsByUid,
  })
  .addRequest({
    requestName: 'guess-price/today-list',
    extraName: 'getGuessPriceTodayList',
    checkLocal: true,
    func: getGuessPriceTodayList,
  })
  .addRequest({
    requestName: 'guess-price/check',
    extraName: 'checkGuessPrice',
    checkLocal: true,
    func: checkGuessPrice,
  })
  .addRequest({
    requestName: 'year-stat/get',
    extraName: 'getYearStat',
    checkLocal: true,
    func: getYearStat,
  })
  .addRequest({
    requestName: 'user/auth',
    extraName: 'auth',
    checkLocal: true,
    async func(_, state) {
      console.log('GA TMG [Auth] 3️⃣ Отправка POST /user/auth', state.authData)
      return auth(state.authData)
    },
    saveData(state) {
      trackGameOpen(state.authData.sessionID)
    },
  })
  .addRequest({
    requestName: 'mark-disposable-modal-as-shown',
    extraName: 'markDisposableModalAsShown',
    checkLocal: true,
    func: markDisposableModalAsShown,
  })
  .addRequest({
    requestName: 'user/beauties-balance',
    extraName: 'getBeautiesBalance',
    checkLocal: true,
    func: getBeautiesBalance,
  })
  .addRequest({
    requestName: 'convert/coins',
    extraName: 'convertToCoins',
    checkLocal: true,
    func: convertToCoins,
  })
  .addRequest({
    requestName: 'user/profile',
    extraName: 'getUserProfile',
    checkLocal: true,
    func: getUserProfile,
  })
  .addRequest({
    requestName: 'user/attempts',
    extraName: 'getAttempts',
    checkLocal: true,
    func: getAttempts,
  })
  .addRequest({
    requestName: 'user/prizes',
    extraName: 'getUserPrizes',
    checkLocal: true,
    func: getUserPrizes,
  })

builder.create()

const requests = builder.export()

export default requests

/**
 * Хук для получения статуса запроса.
 * @param requestName [String] `request/${requestName}`
 * @returns requestData [{local:{currentRequestId, error, state}, global:{currentRequestId, error, state}}]
 */

export const { useRequests, useRequestData } = requests.selectors
